"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IccGroupApi = void 0;
/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
const XHR_1 = require("./XHR");
const Group_1 = require("../model/Group");
const IdWithRev_1 = require("../model/IdWithRev");
const RegistrationSuccess_1 = require("../model/RegistrationSuccess");
const ReplicationInfo_1 = require("../model/ReplicationInfo");
const Unit_1 = require("../model/Unit");
class IccGroupApi {
    constructor(host, headers, fetchImpl) {
        this.host = host;
        this.headers = Object.keys(headers).map((k) => new XHR_1.XHR.Header(k, headers[k]));
        this.fetchImpl = fetchImpl;
    }
    setHeaders(h) {
        this.headers = h;
    }
    handleError(e) {
        throw e;
    }
    /**
     * Create a new group and associated dbs.  The created group will be manageable by the users that belong to the same group as the one that called createGroup. Several tasks can be executed during the group creation like DB replications towards the created DBs, users creation and healthcare parties creation
     * @summary Create a group
     * @param body
     * @param id The id of the group, also used for subsequent authentication against the db (can only contain digits, letters, - and _)
     * @param name The name of the group
     * @param password The password of the group (can only contain digits, letters, - and _)
     * @param server The server on which the group dbs will be created
     * @param q The number of shards for patient and healthdata dbs : 3-8 is a recommended range of value
     * @param n The number of replications for dbs : 3 is a recommended value
     */
    createGroup(id, name, password, server, q, n, body) {
        let _body = null;
        _body = body;
        const _url = this.host +
            `/group/${encodeURIComponent(String(id))}` +
            '?ts=' +
            new Date().getTime() +
            (name ? '&name=' + encodeURIComponent(String(name)) : '') +
            (server ? '&server=' + encodeURIComponent(String(server)) : '') +
            (q ? '&q=' + encodeURIComponent(String(q)) : '') +
            (n ? '&n=' + encodeURIComponent(String(n)) : '');
        let headers = this.headers;
        headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR_1.XHR.Header('Content-Type', 'application/json'));
        password && (headers = headers.concat(new XHR_1.XHR.Header('password', password)));
        return XHR_1.XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl)
            .then((doc) => new Group_1.Group(doc.body))
            .catch((err) => this.handleError(err));
    }
    /**
     * Get a group by id
     * @summary Get a group by id
     * @param id The id of the group
     */
    getGroup(id) {
        let _body = null;
        const _url = this.host + `/group/${encodeURIComponent(String(id))}` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl)
            .then((doc) => new Group_1.Group(doc.body))
            .catch((err) => this.handleError(err));
    }
    /**
     *
     * @summary Get index info
     * @param id The id of the group
     */
    getReplicationInfo1(id) {
        let _body = null;
        const _url = this.host + `/group/${encodeURIComponent(String(id))}/r` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl)
            .then((doc) => new ReplicationInfo_1.ReplicationInfo(doc.body))
            .catch((err) => this.handleError(err));
    }
    /**
     * Init design docs for provided group
     * @summary Init design docs
     * @param id The id of the group
     * @param clazz The class of the design doc
     * @param warmup Warmup the design doc
     */
    initDesignDocs(id, clazz, warmup) {
        let _body = null;
        const _url = this.host +
            `/group/${encodeURIComponent(String(id))}/dd` +
            '?ts=' +
            new Date().getTime() +
            (clazz ? '&clazz=' + encodeURIComponent(String(clazz)) : '') +
            (warmup ? '&warmup=' + encodeURIComponent(String(warmup)) : '');
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('PUT', _url, headers, _body, this.fetchImpl)
            .then((doc) => new Unit_1.Unit(doc.body))
            .catch((err) => this.handleError(err));
    }
    /**
     * List existing groups
     * @summary List groups
     */
    listGroups() {
        let _body = null;
        const _url = this.host + `/group` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl)
            .then((doc) => doc.body.map((it) => new Group_1.Group(it)))
            .catch((err) => this.handleError(err));
    }
    /**
     * Update existing group name
     * @summary Update group name
     * @param id The id of the group
     * @param name The new name for the group
     */
    modifyGroupName(id, name) {
        let _body = null;
        const _url = this.host + `/group/${encodeURIComponent(String(id))}/name/${encodeURIComponent(String(name))}` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('PUT', _url, headers, _body, this.fetchImpl)
            .then((doc) => new Group_1.Group(doc.body))
            .catch((err) => this.handleError(err));
    }
    /**
     * Update existing group properties
     * @summary Update group properties
     * @param body
     * @param id The id of the group
     */
    modifyGroupProperties(id, body) {
        let _body = null;
        _body = body;
        const _url = this.host + `/group/${encodeURIComponent(String(id))}/properties` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR_1.XHR.Header('Content-Type', 'application/json'));
        return XHR_1.XHR.sendCommand('PUT', _url, headers, _body, this.fetchImpl)
            .then((doc) => new Group_1.Group(doc.body))
            .catch((err) => this.handleError(err));
    }
    /**
     * Create a new group and associated dbs.  The created group will be manageable by the users that belong to the same group as the one that called createGroup. Several tasks can be executed during the group creation like DB replications towards the created DBs, users creation and healthcare parties creation
     * @summary Create a group
     * @param body
     */
    registerNewGroupAdministrator(body) {
        let _body = null;
        _body = body;
        const _url = this.host + `/group/register/trial` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR_1.XHR.Header('Content-Type', 'application/json'));
        return XHR_1.XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl)
            .then((doc) => new RegistrationSuccess_1.RegistrationSuccess(doc.body))
            .catch((err) => this.handleError(err));
    }
    /**
     * Reset storage
     * @summary Reset storage for group
     * @param body
     * @param id The id of the group
     * @param q The number of shards for patient and healthdata dbs : 3-8 is a recommended range of value
     * @param n The number of replications for dbs : 3 is a recommended value
     */
    resetStorage(id, q, n, body) {
        let _body = null;
        _body = body;
        const _url = this.host +
            `/group/${encodeURIComponent(String(id))}/reset/storage` +
            '?ts=' +
            new Date().getTime() +
            (q ? '&q=' + encodeURIComponent(String(q)) : '') +
            (n ? '&n=' + encodeURIComponent(String(n)) : '');
        let headers = this.headers;
        headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR_1.XHR.Header('Content-Type', 'application/json'));
        return XHR_1.XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl)
            .then((doc) => new Unit_1.Unit(doc.body))
            .catch((err) => this.handleError(err));
    }
    /**
     * Update password for provided group
     * @summary Set group password
     * @param id The id of the group
     * @param password The new password for the group (can only contain digits, letters, - and _)
     */
    setGroupPassword(id, password) {
        let _body = null;
        const _url = this.host + `/group/${encodeURIComponent(String(id))}/password` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        password && (headers = headers.concat(new XHR_1.XHR.Header('password', password)));
        return XHR_1.XHR.sendCommand('PUT', _url, headers, _body, this.fetchImpl)
            .then((doc) => new Group_1.Group(doc.body))
            .catch((err) => this.handleError(err));
    }
    /**
     * Solve conflicts for group
     * @summary Solve conflicts for group
     * @param id The id of the group
     * @param limit Solve at most limit conflicts
     * @param warmup Warmup the design doc
     */
    solveConflicts(id, limit, warmup) {
        let _body = null;
        const _url = this.host +
            `/group/${encodeURIComponent(String(id))}/conflicts` +
            '?ts=' +
            new Date().getTime() +
            (limit ? '&limit=' + encodeURIComponent(String(limit)) : '') +
            (warmup ? '&warmup=' + encodeURIComponent(String(warmup)) : '');
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl)
            .then((doc) => doc.body.map((it) => new IdWithRev_1.IdWithRev(it)))
            .catch((err) => this.handleError(err));
    }
}
exports.IccGroupApi = IccGroupApi;
//# sourceMappingURL=IccGroupApi.js.map